// Author Lin
// Date 2024-06-11 14:17:58

class SithMesInventoryPackage {
    constructor({
                    id = null,
                    packageNo = '',
                    boxNo = '',
                    boxSource = '',
                    proWbs = '',
                    description = '',
                    length = '',
                    width = '',
                    height = '',
                    netWeight = '',
                    roughWeight = '',
                    storageLocId = '',
                    isChecked = '',
                    checkedDate = '',
                    unpackageReason = '',
                    logisticsStatus = '',
                    shipmentNo = '',
                    bottomJoistDesc = '',
                    packerId = '',
                    packageCountWorker = '',
                    checkerId = '',
                    reviewerId = '',
                    parentId = '',
                    packageType = '',
                    packagePr = '',
                    prItem = '',
                    attachment = '',
                    remark = '',
                    unpackingTime = '',
                    unpackingCheckWorkerLogin = '',
                    unpackingOrNot = '',
                    accountMatchActualSituationOrNot = '',
                    unpackingReportOrNot = '',
                    unpackingReport = '',
                    packFinishTime = '',
                    attachmentList = '',
                    unpackingReportList = ''
                }
                    = {}) {
        this.id = id;
        this.packageNo = packageNo;
        this.boxNo = boxNo;
        this.boxSource = boxSource;
        this.proWbs = proWbs;
        this.description = description;
        this.length = length;
        this.width = width;
        this.height = height;
        this.netWeight = netWeight;
        this.roughWeight = roughWeight;
        this.storageLocId = storageLocId;
        this.isChecked = isChecked;
        this.checkedDate = checkedDate;
        this.unpackageReason = unpackageReason;
        this.logisticsStatus = logisticsStatus;
        this.shipmentNo = shipmentNo;
        this.bottomJoistDesc = bottomJoistDesc;
        this.packerId = packerId;
        this.packageCountWorker = packageCountWorker;
        this.checkerId = checkerId;
        this.reviewerId = reviewerId;
        this.parentId = parentId;
        this.packageType = packageType;
        this.packagePr = packagePr;
        this.prItem = prItem;
        this.attachment = attachment;
        this.remark = remark;
        this.unpackingTime = unpackingTime;
        this.unpackingCheckWorkerLogin = unpackingCheckWorkerLogin;
        this.unpackingOrNot = unpackingOrNot;
        this.accountMatchActualSituationOrNot = accountMatchActualSituationOrNot;
        this.unpackingReportOrNot = unpackingReportOrNot;
        this.unpackingReport = unpackingReport;
        this.packFinishTime = packFinishTime;
        this.attachmentList = attachmentList;
        this.unpackingReportList = unpackingReportList;
    }
}

function newEntity() {
    return new SithMesInventoryPackage();
}

function gridFields() {
    return Object.freeze([
        {
            key: 'id',
            label: 'label.sith.inventory.sithMesInventoryPackage.grid.id',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'packageNo',
            label: 'label.sith.inventory.sithMesInventoryPackage.grid.packageNo',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'boxNo',
            label: 'label.sith.inventory.sithMesInventoryPackage.grid.boxNo',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'boxSource',
            label: 'label.sith.inventory.sithMesInventoryPackage.grid.boxSource',
            sortable: true,
            form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                , options: [
                    {value: '1', text: '新制'},
                    {value: '2', text: '旧箱'},
                    {value: '3', text: '改造'},
                    {value: '4', text: '裸装'},
                    {value: '5', text: '防雨布包装'},
                    {value: '6', text: '五面体'},
                    {value: '7', text: '单独报价'}
                ]
            }
        },
        {
            key: 'proWbs',
            label: 'label.sith.inventory.sithMesInventoryPackage.grid.proWbs',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'projectCode',
            label: 'label.sith.inventory.sithMesInventoryPackage.grid.projectCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'projectName',
            label: 'label.sith.inventory.sithMesInventoryPackage.grid.projectName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'description',
            label: 'label.sith.inventory.sithMesInventoryPackage.grid.description',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'length',
            label: 'label.sith.inventory.sithMesInventoryPackage.grid.length',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'width',
            label: 'label.sith.inventory.sithMesInventoryPackage.grid.width',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'height',
            label: 'label.sith.inventory.sithMesInventoryPackage.grid.height',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'netWeight',
            label: 'label.sith.inventory.sithMesInventoryPackage.grid.netWeight',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'roughWeight',
            label: 'label.sith.inventory.sithMesInventoryPackage.grid.roughWeight',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'storageLocId',
            label: 'label.sith.inventory.sithMesInventoryPackage.grid.storageLocId',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'areaName',
            label: 'label.sith.inventory.sithMesInventoryPackage.grid.areaName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'isChecked',
            label: 'label.sith.inventory.sithMesInventoryPackage.grid.isChecked',
            sortable: true,
            form: {
                type: 'boolean',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'checkedDate',
            label: 'label.sith.inventory.sithMesInventoryPackage.grid.checkedDate',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'unpackageReason',
            label: 'label.sith.inventory.sithMesInventoryPackage.grid.unpackageReason',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'logisticsStatus',
            label: 'label.sith.inventory.sithMesInventoryPackage.grid.logisticsStatus',
            sortable: true,
            form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                , options: [
                    {value: '1', text: '包装中'},
                    {value: '2', text: '已审核'},
                    {value: '3', text: '已复核'},
                    {value: '4', text: '已封箱'},
                    {value: '5', text: '已装车'}
                ]
            }
        },
        {
            key: 'shipmentNo',
            label: 'label.sith.inventory.sithMesInventoryPackage.grid.shipmentNo',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'bottomJoistDesc',
            label: 'label.sith.inventory.sithMesInventoryPackage.grid.bottomJoistDesc',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'packerId',
            label: 'label.sith.inventory.sithMesInventoryPackage.grid.packerId',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'packer',
            label: 'label.sith.inventory.sithMesInventoryPackage.grid.packer',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'packageCountWorker',
            label: 'label.sith.inventory.sithMesInventoryPackage.grid.packageCountWorker',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'packageCountWorkerName',
            label: 'label.sith.inventory.sithMesInventoryPackage.grid.packageCountWorkerName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'checkerId',
            label: 'label.sith.inventory.sithMesInventoryPackage.grid.checkerId',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'checker',
            label: 'label.sith.inventory.sithMesInventoryPackage.grid.checker',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'reviewer',
            label: 'label.sith.inventory.sithMesInventoryPackage.grid.reviewer',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'reviewerId',
            label: 'label.sith.inventory.sithMesInventoryPackage.grid.reviewerId',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'parentId',
            label: 'label.sith.inventory.sithMesInventoryPackage.grid.parentId',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'packageType',
            label: 'label.sith.inventory.sithMesInventoryPackage.grid.packageType',
            sortable: true,
            form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                , options: [
                    {value: '1', text: '内箱'},
                    {value: '2', text: '外箱'},
                    {value: '3', text: '虚拟箱'}
                ]
            }
        },
        {
            key: 'packagePr',
            label: 'label.sith.inventory.sithMesInventoryPackage.grid.packagePr',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'prItem',
            label: 'label.sith.inventory.sithMesInventoryPackage.grid.prItem',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'attachmentList',
            label: 'label.sith.inventory.sithMesInventoryPackage.grid.attachmentList',
            sortable: true,
            isDetail: true,
            form: {
                type: 'emAttachment',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'remark',
            label: 'label.sith.inventory.sithMesInventoryPackage.grid.remark',
            sortable: true,
            isDetail: true,
            form: {
                type: 'textarea',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'unpackingTime',
            label: 'label.sith.inventory.sithMesInventoryPackage.grid.unpackingTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'unpackingCheckWorkerLogin',
            label: 'label.sith.inventory.sithMesInventoryPackage.grid.unpackingCheckWorkerLogin',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'unpackingCheckWorkerName',
            label: 'label.sith.inventory.sithMesInventoryPackage.grid.unpackingCheckWorkerName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'unpackingOrNot',
            label: 'label.sith.inventory.sithMesInventoryPackage.grid.unpackingOrNot',
            sortable: true,
            form: {
                type: 'boolean',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'accountMatchActualSituationOrNot',
            label: 'label.sith.inventory.sithMesInventoryPackage.grid.accountMatchActualSituationOrNot',
            sortable: true,
            form: {
                type: 'boolean',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'unpackingReportOrNot',
            label: 'label.sith.inventory.sithMesInventoryPackage.grid.unpackingReportOrNot',
            sortable: true,
            form: {
                type: 'boolean',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'unpackingReportList',
            label: 'label.sith.inventory.sithMesInventoryPackage.grid.unpackingReportList',
            sortable: true,
            isDetail: true,
            form: {
                type: 'emAttachment',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'createdTime',
            label: 'label.sith.inventory.sithMesInventoryPackage.grid.createdTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
    ])
}

const filter = {
    idFilter: '',
    idListFilter: [],
    packageNoFilter: '',
    boxNoFilter: '',
    boxSourceFilter: '',
    proWbsFilter: '',
    descriptionFilter: '',
    lengthFilter: '',
    widthFilter: '',
    heightFilter: '',
    netWeightFilter: '',
    roughWeightFilter: '',
    storageLocIdFilter: '',
    isCheckedFilter: '',
    checkedDateRteFilter: '',
    checkedDateLteFilter: '',
    unpackageReasonFilter: '',
    logisticsStatusFilter: '',
    shipmentNoFilter: '',
    packerIdFilter: '',
    packageCountWorkerFilter: '',
    checkerIdFilter: '',
    reviewerIdFilter: '',
    parentIdFilter: '',
    packageTypeFilter: '',
    packagePrFilter: '',
    prItemFilter: '',
    unpackingTimeRteFilter: '',
    unpackingTimeLteFilter: '',
    unpackingCheckWorkerLoginFilter: '',
    unpackingOrNotFilter: '',
    accountMatchActualSituationOrNotFilter: '',
    unpackingReportOrNotFilter: '',
    createdTimeRteFilter: '',
    createdTimeLteFilter: ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
    {
        key: 'packageNoFilter',
        label: 'label.sith.inventory.sithMesInventoryPackage.filter.packageNo',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'boxNoFilter',
        label: 'label.sith.inventory.sithMesInventoryPackage.filter.boxNo',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'boxSourceFilter',
        label: 'label.sith.inventory.sithMesInventoryPackage.filter.boxSource',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '新制'},
                {value: '2', text: '旧箱'},
                {value: '3', text: '改造'},
                {value: '4', text: '裸装'},
                {value: '5', text: '防雨布包装'},
                {value: '6', text: '五面体'},
                {value: '7', text: '单独报价'}
            ]
        }
    },
    {
        key: 'proWbsFilter',
        label: 'label.sith.inventory.sithMesInventoryPackage.filter.proWbs',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesPrdProjectInfo'
            , correspondingField: 'wbsNumber'
        }
    },
    {
        key: 'descriptionFilter',
        label: 'label.sith.inventory.sithMesInventoryPackage.filter.description',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'lengthFilter',
        label: 'label.sith.inventory.sithMesInventoryPackage.filter.length',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'widthFilter',
        label: 'label.sith.inventory.sithMesInventoryPackage.filter.width',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'heightFilter',
        label: 'label.sith.inventory.sithMesInventoryPackage.filter.height',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'netWeightFilter',
        label: 'label.sith.inventory.sithMesInventoryPackage.filter.netWeight',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'roughWeightFilter',
        label: 'label.sith.inventory.sithMesInventoryPackage.filter.roughWeight',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'storageLocIdFilter',
        label: 'label.sith.inventory.sithMesInventoryPackage.filter.storageLocId',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesInventoryAreaLoc'
            , correspondingField: 'id'
        }
    },
    {
        key: 'isCheckedFilter',
        label: 'label.sith.inventory.sithMesInventoryPackage.filter.isChecked',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'checkedDateRteFilter',
        label: 'label.sith.inventory.sithMesInventoryPackage.filter.checkedDateRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'checkedDateLteFilter',
        label: 'label.sith.inventory.sithMesInventoryPackage.filter.checkedDateLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'unpackageReasonFilter',
        label: 'label.sith.inventory.sithMesInventoryPackage.filter.unpackageReason',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'logisticsStatusFilter',
        label: 'label.sith.inventory.sithMesInventoryPackage.filter.logisticsStatus',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '包装中'},
                {value: '2', text: '已审核'},
                {value: '3', text: '已复核'},
                {value: '4', text: '已封箱'},
                {value: '5', text: '已装车'}
            ]
        }
    },
    {
        key: 'shipmentNoFilter',
        label: 'label.sith.inventory.sithMesInventoryPackage.filter.shipmentNo',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'packerIdFilter',
        label: 'label.sith.inventory.sithMesInventoryPackage.filter.packerId',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'id'
        }
    },
    {
        key: 'packageCountWorkerFilter',
        label: 'label.sith.inventory.sithMesInventoryPackage.filter.packageCountWorker',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'checkerIdFilter',
        label: 'label.sith.inventory.sithMesInventoryPackage.filter.checkerId',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'id'
        }
    },
    {
        key: 'reviewerIdFilter',
        label: 'label.sith.inventory.sithMesInventoryPackage.filter.reviewerId',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'id'
        }
    },
    {
        key: 'parentIdFilter',
        label: 'label.sith.inventory.sithMesInventoryPackage.filter.parentId',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesInventoryPackage'
            , correspondingField: 'id'
        }
    },
    {
        key: 'packageTypeFilter',
        label: 'label.sith.inventory.sithMesInventoryPackage.filter.packageType',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '内箱'},
                {value: '2', text: '外箱'},
                {value: '3', text: '虚拟箱'}
            ]
        }
    },
    {
        key: 'packagePrFilter',
        label: 'label.sith.inventory.sithMesInventoryPackage.filter.packagePr',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prItemFilter',
        label: 'label.sith.inventory.sithMesInventoryPackage.filter.prItem',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'unpackingTimeRteFilter',
        label: 'label.sith.inventory.sithMesInventoryPackage.filter.unpackingTimeRte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'unpackingTimeLteFilter',
        label: 'label.sith.inventory.sithMesInventoryPackage.filter.unpackingTimeLte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'unpackingCheckWorkerLoginFilter',
        label: 'label.sith.inventory.sithMesInventoryPackage.filter.unpackingCheckWorkerLogin',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'unpackingOrNotFilter',
        label: 'label.sith.inventory.sithMesInventoryPackage.filter.unpackingOrNot',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'accountMatchActualSituationOrNotFilter',
        label: 'label.sith.inventory.sithMesInventoryPackage.filter.accountMatchActualSituationOrNot',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'unpackingReportOrNotFilter',
        label: 'label.sith.inventory.sithMesInventoryPackage.filter.unpackingReportOrNot',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'createdTimeRteFilter',
        label: 'label.sith.inventory.sithMesInventoryPackage.filter.createdTimeRte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'createdTimeLteFilter',
        label: 'label.sith.inventory.sithMesInventoryPackage.filter.createdTimeLte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    }
];


const entityFormConfigs = [
    {
        key: 'packageNo',
        label: 'label.sith.inventory.sithMesInventoryPackage.entity.packageNo',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'boxNo',
        label: 'label.sith.inventory.sithMesInventoryPackage.entity.boxNo',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'boxSource',
        label: 'label.sith.inventory.sithMesInventoryPackage.entity.boxSource',
        sortable: true,
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '新制'},
                {value: '2', text: '旧箱'},
                {value: '3', text: '改造'},
                {value: '4', text: '裸装'},
                {value: '5', text: '防雨布包装'},
                {value: '6', text: '五面体'},
                {value: '7', text: '单独报价'}
            ]
        }
    },
    {
        key: 'proWbs',
        label: 'label.sith.inventory.sithMesInventoryPackage.entity.proWbs',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesPrdProjectInfo'
            , correspondingField: 'wbsNumber'
        }
    },
    {
        key: 'description',
        label: 'label.sith.inventory.sithMesInventoryPackage.entity.description',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'length',
        label: 'label.sith.inventory.sithMesInventoryPackage.entity.length',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'width',
        label: 'label.sith.inventory.sithMesInventoryPackage.entity.width',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'height',
        label: 'label.sith.inventory.sithMesInventoryPackage.entity.height',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'netWeight',
        label: 'label.sith.inventory.sithMesInventoryPackage.entity.netWeight',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'roughWeight',
        label: 'label.sith.inventory.sithMesInventoryPackage.entity.roughWeight',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'storageLocId',
        label: 'label.sith.inventory.sithMesInventoryPackage.entity.storageLocId',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesInventoryAreaLoc'
            , correspondingField: 'id'
        }
    },
    {
        key: 'isChecked',
        label: 'label.sith.inventory.sithMesInventoryPackage.entity.isChecked',
        sortable: true,
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'checkedDate',
        label: 'label.sith.inventory.sithMesInventoryPackage.entity.checkedDate',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'unpackageReason',
        label: 'label.sith.inventory.sithMesInventoryPackage.entity.unpackageReason',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'logisticsStatus',
        label: 'label.sith.inventory.sithMesInventoryPackage.entity.logisticsStatus',
        sortable: true,
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '包装中'},
                {value: '2', text: '已审核'},
                {value: '3', text: '已复核'},
                {value: '4', text: '已封箱'},
                {value: '5', text: '已装车'}
            ]
        }
    },
    {
        key: 'shipmentNo',
        label: 'label.sith.inventory.sithMesInventoryPackage.entity.shipmentNo',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'bottomJoistDesc',
        label: 'label.sith.inventory.sithMesInventoryPackage.entity.bottomJoistDesc',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'packerId',
        label: 'label.sith.inventory.sithMesInventoryPackage.entity.packerId',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'id'
        }
    },
    {
        key: 'packageCountWorker',
        label: 'label.sith.inventory.sithMesInventoryPackage.entity.packageCountWorker',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'checkerId',
        label: 'label.sith.inventory.sithMesInventoryPackage.entity.checkerId',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'id'
        }
    },
    {
        key: 'reviewerId',
        label: 'label.sith.inventory.sithMesInventoryPackage.entity.reviewerId',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'id'
        }
    },
    {
        key: 'parentId',
        label: 'label.sith.inventory.sithMesInventoryPackage.entity.parentId',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesInventoryPackage'
            , correspondingField: 'id'
        }
    },
    {
        key: 'packageType',
        label: 'label.sith.inventory.sithMesInventoryPackage.entity.packageType',
        sortable: true,
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '内箱'},
                {value: '2', text: '外箱'},
                {value: '3', text: '虚拟箱'}
            ]
        }
    },
    {
        key: 'packagePr',
        label: 'label.sith.inventory.sithMesInventoryPackage.entity.packagePr',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prItem',
        label: 'label.sith.inventory.sithMesInventoryPackage.entity.prItem',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'remark',
        label: 'label.sith.inventory.sithMesInventoryPackage.entity.remark',
        sortable: true,
        disabled: false,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'unpackingTime',
        label: 'label.sith.inventory.sithMesInventoryPackage.entity.unpackingTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'unpackingCheckWorkerLogin',
        label: 'label.sith.inventory.sithMesInventoryPackage.entity.unpackingCheckWorkerLogin',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'unpackingOrNot',
        label: 'label.sith.inventory.sithMesInventoryPackage.entity.unpackingOrNot',
        sortable: true,
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'accountMatchActualSituationOrNot',
        label: 'label.sith.inventory.sithMesInventoryPackage.entity.accountMatchActualSituationOrNot',
        sortable: true,
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'unpackingReportOrNot',
        label: 'label.sith.inventory.sithMesInventoryPackage.entity.unpackingReportOrNot',
        sortable: true,
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'attachmentList',
        label: 'label.sith.inventory.sithMesInventoryPackage.entity.attachment',
        sortable: false,
        disabled: false,
        form: {
            type: 'emAttachment',
            modalMultiSelectedType: 'string'
            , correspondingField: 'attachment'
        }
    },
    {
        key: 'unpackingReportList',
        label: 'label.sith.inventory.sithMesInventoryPackage.entity.unpackingReport',
        sortable: false,
        disabled: false,
        form: {
            type: 'emAttachment',
            modalMultiSelectedType: 'string'
            , correspondingField: 'unpackingReport'
        }
    }
]

export {
    SithMesInventoryPackage, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
    , filterConfigs


}
